export const WELLS_BASE_URL = `${process.env.REACT_APP_ENDPOINT}/api/wells-management`;
export const WELL_PK_FIELD = "well_ndx";

export const COLUMNS = [
  { field: "well_ndx", headerName: "Well", editable: false, width: 130 },
  { field: "id_address", headerName: "Id Address", editable: true, width: 130 },
  { field: "id_well", headerName: "Id Well", editable: true, width: 130 },
  {
    field: "id_well_status",
    headerName: "Id Well Status",
    editable: true,
    width: 130,
  },
  {
    field: "id_well_report_tracking_number",
    headerName: "Well Report Tracking Number SDR",
    editable: true,
    width: 130,
  },
  { field: "well_name", headerName: "Well Name", editable: true, width: 130 },
  {
    field: "id_district",
    headerName: "Id District",
    editable: true,
    width: 130,
  },
  {
    field: "longitude",
    headerName: "Longitude",
    editable: true,
    type: "number",
    width: 180,
  },
  {
    field: "latitude",
    headerName: "Latitude",
    editable: true,
    type: "number",
    width: 180,
  },
  {
    field: "ft_elevation",
    headerName: "Ft Elevation",
    editable: true,
    width: 130,
  },
  {
    field: "ft_measure_point",
    headerName: "Ft Measure Point",
    editable: true,
    width: 130,
  },
  {
    field: "grid_number",
    headerName: "Grid Number",
    editable: true,
    width: 130,
  },
  { field: "tax_parcel", headerName: "Tax Parcel", editable: true, width: 130 },
  {
    field: "id_ncdc_station",
    headerName: "Id Ncdc Station",
    editable: true,
    width: 130,
  },
  {
    field: "well_report_static_water_level",
    headerName: "Well Report Static Water Level",
    editable: true,
    width: 130,
  },
  { field: "id_aquifer", headerName: "Id Aquifer", editable: true, width: 130 },
  {
    field: "id_aquifer_strata",
    headerName: "Id Aquifer Strata",
    editable: true,
    width: 130,
  },
  {
    field: "sample_well",
    headerName: "Sample Well",
    editable: true,
    width: 130,
  },
  { field: "gamma_log", headerName: "Gamma Log", editable: true, width: 130 },
  {
    field: "transducer_well",
    headerName: "Transducer Well",
    editable: true,
    width: 130,
  },
  {
    field: "monitoring_well",
    headerName: "Monitoring Well",
    editable: true,
    width: 130,
  },
  {
    field: "method_measure",
    headerName: "Method Measure",
    editable: true,
    width: 130,
  },
  {
    field: "monitoring_start_date",
    headerName: "Monitoring Start Date",
    editable: true,
    type: "date",
    valueGetter: (params) =>
      params && params.value ? new Date(params.value) : null,
    width: 150,
  },
  {
    field: "monitoring_end_date",
    headerName: "Monitoring End Date",
    editable: true,
    type: "date",
    valueGetter: (params) =>
      params && params.value ? new Date(params.value) : null,
    width: 150,
  },
  { field: "comment", headerName: "Comment", editable: true, width: 200 },
];
